import { useNavigate } from 'react-router';

const useReactRouterNavigation = () => {
  try {
    return useNavigate(); // Will throw if not inside a <Router>
  } catch {
    return null;
  }
};

export const useBackwardsCompatibleNavigate = () => {
  const reactNavigate = useReactRouterNavigation(); // Will be null if not in a Router

  return (path: string) => {
    if (reactNavigate) {
      reactNavigate(path);
    } else {
      window.location.assign(path);
    }
  };
};
